<div id="ndvi-distribution-color-legend-modal">
  <div class="row mb-3">
    <div class="col-8">
      <div class="d-flex justify-content-between">
        <span class="spectrum-label">{{ 'doktar_app.common.lowest' | translate }}</span>
        <span class="spectrum-label">{{ 'doktar_app.common.highest' | translate }}</span>
      </div>
      <div class="bar gradient" [class.ndmi]="showNdmiGradient"></div>
    </div>
    <div class="col-4">
      <span class="spectrum-label">{{ 'doktar_app.common.cloud' | translate }}</span>
      <div class="bar cloud"></div>
    </div>
  </div>

  <div class="d-flex">
    <span>
      <i class="ph-fill ph-info"></i>
    </span>
    <span>
      <p class="px-2">
        {{ descriptionKey | translate }}
      </p>
    </span>
  </div>

  @for (legend of legends; track legend) {
    <div class="d-flex align-items-center gap-2">
      <div class="color-box" [class.light-swatch]="isLightSwatch(legend.color)" [style.backgroundColor]="legend.color"></div>
      <div class="title">{{ legend.title | translate }}</div>
    </div>
    <p class="description">{{ legend.description | translate }}</p>
  }
</div>
